import { conversation } from 'services';
import { API_CONVERSATION_REASONS } from 'utils/constants';

const getAllServiceReasons = () => {
  return conversation.get(API_CONVERSATION_REASONS);
};

export { getAllServiceReasons };
